import React from 'react';
import { Box, Heading } from '@chakra-ui/react';

interface PageTitleProps {
    title: string;
    size?: 'xl' | '2xl';
}

const PageTitle: React.FC<PageTitleProps> = ({ title, size = 'xl' }) => {
    return (
        <Box bg="gray.100" py={2} textAlign="center">
            <Heading size={size} color="gray.800" my={2} style={{ fontFamily: "'Oswald', sans-serif" }}>
                {title}
            </Heading>
        </Box>
    );
};

export default PageTitle;
